/**
 * CTABlock Molecule Component
 * Call-to-action block with optional title, description, and button
 */

import React from "react";
import { storyblokEditable } from "@/lib/blocks";
import { Button } from "@/components/atoms/Button";
import { getStoryblokLinkUrl } from "@/lib/storyblok-utils";
import type { CTABlockBlok } from "@/types";

export interface CTABlockProps {
  blok: CTABlockBlok;
  className?: string;
}

export const CTABlock: React.FC<CTABlockProps> = ({ blok, className = "" }) => {
  const { button_text, button_link, button_variant = "primary" } = blok;

  return (
    <div
      {...storyblokEditable(blok)}
      className={`flex flex-col gap-4 ${className}`}
    >
      <div>
        <Button
          href={getStoryblokLinkUrl(button_link)}
          variant={button_variant}
          className="inline-flex"
        >
          {button_text}
        </Button>
      </div>
    </div>
  );
};

export default CTABlock;
